import { useMemo } from "react";
import { usePathname } from "next/navigation";

import { useTopBarActionResolvers } from "@/top-bar-actions";
import {
  findRouteChain,
  findSettingsRouteByPathname,
} from "@/config/navigation";

/** Actions for the current page's leaf route (invoked on each render). */
export function useRenderedTopBarActions() {
  const pathname = usePathname() ?? "/";
  const resolvers = useTopBarActionResolvers();

  const routePath = useMemo(() => {
    const chain = findRouteChain(pathname);
    const fromChain = chain[chain.length - 1]?.path;
    if (fromChain) return fromChain;
    return findSettingsRouteByPathname(pathname)?.path ?? "";
  }, [pathname]);

  const resolver = routePath ? resolvers[routePath] : undefined;
  return resolver?.() ?? null;
}
